// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from './Components/Home/ThemeContext';
import Header from './Components/Header/header';
import Footer from './Components/Footer/Footer';
import AppRoutes from './routes/AppRoutes';
import ScrollToTop from './Components/ScrollTop/ScrollToTop';
import ThemeSelector from './Components/Home/ThemeSelector';
import { AuthProvider } from "./context/AuthContext";

function App() {
  return (
    <AuthProvider> {/* 🔥 GLOBAL AUTH WRAPPER */}
      <ThemeProvider>
        <Router>
          <ScrollToTop />
          <Header />
          <AppRoutes />
          <Footer />

          {/* 🎨 GLOBAL THEME PICKER */}
          <ThemeSelector />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
